"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = require("@chakra-ui/react");
var _react2 = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @example (
 * <ToggleButtonGroup onChange={handleChangeValue} value={value}>
 *  <Button value={value1}>label1</Button>
 *  <Button value={value2}>label2</Button>
 * </ToggleButtonGroup>
 * )
 * @note
 * must have multiple child elements
 */
const ToggleButtonGroup = /*#__PURE__*/(0, _react2.forwardRef)((props, ref) => {
  const {
    onChange,
    value,
    children,
    groupProps
  } = props;
  if (!children) throw new Error('Children required');

  // iterate over array of child nodes to apply extended props
  return /*#__PURE__*/_react2.default.createElement(_react.ButtonGroup, (0, _extends2.default)({
    ref: ref,
    sx: {
      ..._styles.buttonGroupStyles
    }
  }, groupProps), _react2.default.Children.map(children, CHILD => {
    return /*#__PURE__*/_react2.default.cloneElement(CHILD, {
      onClick: () => {
        if (value === CHILD?.props?.value) return;
        onChange(CHILD?.props?.value);
      },
      ...(value !== CHILD?.props?.value ? {
        sx: {
          ..._styles.defaultStyles,
          ..._styles.inactiveStyles
        }
      } : {
        sx: {
          ..._styles.defaultStyles,
          ..._styles.activeStyles
        }
      })
    });
  }));
});
var _default = exports.default = ToggleButtonGroup;